import { useSelector } from 'react-redux'
import useSWR from 'swr'
import { coreApi } from '../../../services/api'
import { RootState } from '../../../store/modules/rootReducer'
import { IProgress } from '../components/DashboardContent/types'

const getFetcher = (authToken: string) => (url: string) =>
  coreApi.get(url, { headers: { Authorization: `Bearer ${authToken}` } }).then((res) => res.data)

export const useGetProgress = (courseId: string | null | undefined) => {
  const { student, auth } = useSelector((state: RootState) => ({
    student: state.student,
    auth: state.auth,
  }))

  const shouldFetch = !!courseId && !!auth.token

  const fetcher = getFetcher(auth.token)

  const key = shouldFetch
    ? `/students/dashboard/student/${student.profile._id}/course/${courseId}/progress`
    : null

  const options = {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  }

  return useSWR<IProgress>(key, fetcher, options)
}
